import { render, staticRenderFns } from "./BSShowReviews.vue?vue&type=template&id=4457bb74"
import script from "./BSShowReviews.vue?vue&type=script&lang=js"
export * from "./BSShowReviews.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports